import styled, { css } from "styled-components";

const activeStyles = css`
  background-color: #353a50;
  border-radius: 12px;
  color: white;

  g > * {
    stroke: white;
  }
`;

export const CarSingleStyled = styled.button`
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin: auto;
  margin-top: 6px;
  margin-bottom: 6px;

  border-radius: 12px;
  background-color: ${({ second }) => (second ? "#EAEBED" : "transparent")};
  padding: 0 18px 0 14px;
  border-bottom: ${({ second }) => !second && "solid 0.5px #2a2e43;"};

  transition: 0.5s;

  ${({ active }) => (active ? activeStyles : null)};

  .car-single__img {
    /* margin-bottom: -15px; */
  }
`;
